// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSpinner_loader__Z8ONC","load5":"LoadingSpinner_load5__aOqlZ"};